// extracted by mini-css-extract-plugin
module.exports = {"card":"CardMini_card__sZcai","textContainer":"CardMini_textContainer__pSfcm","imageContainer":"CardMini_imageContainer__Phj8y"};